import { gql } from '@apollo/client';
import {
  CooperativeMember,
  CooperativeMemberEntityType,
  CooperativeMemberModalityType,
} from 'cooperatives/models/cooperativeMember';

export interface CooperativeMemberCreateMutationInput {
  cooperativeMemberEmail: string;
  cooperativeMemberLegalName: string;
  cooperativeMemberDocumentId: string;
  cooperativeMemberOptionalEmail?: string[] | null;
  cooperativeMemberEntityType: CooperativeMemberEntityType;
  cooperativeMemberModalityType: CooperativeMemberModalityType | null;
  cooperativeId: number;
}

export interface CooperativeMemberCreateMutationVariables {
  cooperativeMemberCreateInput: CooperativeMemberCreateMutationInput;
}

export interface CooperativeMemberCreated {
  cooperativeMemberCreate: CooperativeMember;
}

export const COOPERATIVE_MEMBER_CREATE_MUTATION = gql`
  mutation cooperativeMemberCreate(
    $cooperativeMemberCreateInput: cooperativeMemberCreateInput!
  ) {
    cooperativeMemberCreate(input: $cooperativeMemberCreateInput) {
      id
      cooperativeMemberEmail
      cooperativeMemberLegalName
      cooperativeMemberEntityType
      cooperativeMemberDocumentId
      cooperativeMemberModalityType
      cooperativeMemberOptionalEmail
      cooperative {
        cooperativeLegalName
      }
    }
  }
`;
